import { render, staticRenderFns } from "./IP_Summary.vue?vue&type=template&id=16db9459&scoped=true&"
import script from "./IP_Summary.vue?vue&type=script&lang=js&"
export * from "./IP_Summary.vue?vue&type=script&lang=js&"
import style0 from "./IP_Summary.vue?vue&type=style&index=0&id=16db9459&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16db9459",
  null
  
)

export default component.exports